import { render, staticRenderFns } from "./DineIn.vue?vue&type=template&id=484abca0"
import script from "./DineIn.vue?vue&type=script&lang=js"
export * from "./DineIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports